export default "__VITE_PUBLIC_ASSET__98def96a__"